import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "case-photo-sidebar-content__form" }
const _hoisted_2 = { class: "frame other" }
const _hoisted_3 = { class: "frame__overview" }
const _hoisted_4 = { class: "frame__header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_6 = { class: "n-page__statistics" }
const _hoisted_7 = { class: "cluster-events" }
const _hoisted_8 = { class: "cluster-events__loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_CasePhotoForm = _resolveComponent("CasePhotoForm")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_CaseClusterEvent = _resolveComponent("CaseClusterEvent")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", {
    class: "case-photo-sidebar-content",
    key: _ctx.item.id
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_NThumbnail, {
        class: "case-photo-sidebar-content__thumbnail",
        "model-value": _ctx.item.thumbnail,
        onClick: _ctx.showFullscreen
      }, null, 8, ["model-value", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CasePhotoForm, {
        ref: "form",
        item: _ctx.item,
        disabled: _ctx.disabled
      }, null, 8, ["item", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('common.photo_cluster_events', 'f')), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
        _createVNode(_component_SortDropdown, {
          items: _ctx.sortTypes,
          modelValue: _ctx.module.filter.current.ordering,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
        }, null, 8, ["items", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.module.items, (item) => {
          return (_openBlock(), _createBlock(_component_CaseClusterEvent, {
            key: item.id,
            item: item,
            onAction: (type) => _ctx.actionHandler(type, item)
          }, null, 8, ["item", "onAction"]))
        }), 128)),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.module.loading || _ctx.module.appending)
            ? (_openBlock(), _createBlock(_component_NLoadingCircle, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_InfiniteScroll, {
          filters: _ctx.module.filter.current,
          onLoadMore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.module.append()))
        }, null, 8, ["filters"])
      ])
    ])
  ]))
}